module.exports = "../dist/frontend/icons/ui/categoryRocket.svg?e640f5b7c1a29cd0a43c65759fed207a";